import Modules from '@/model/modules';
import {RouteModule} from '@/types/route-type';
import RecommendDetail from './recommend-detail/recommend-detail';
import RecommendList from './recommend-list/recommend-list';
import RecommendSell from './recommend-sell/recommend-sell';

const Module: RouteModule = {
    module: Modules.RECOMMEND,
    pages: [
        {
            path: '/recommend',
            element: RecommendList,
        },
        {
            path: '/recommend/:id',
            element: RecommendDetail,
        },
        {
            path: '/recommend/sell',
            element: RecommendSell,
        },
    ],
};

export default Module;
